import { Organization } from "./organization";
import { Producer } from "./producer";
import { Arena } from "./arena";

import { RodeoEvent } from "./rodeoEvent";
import { Secretary } from "./secretary";
import { Exhibition } from "./exhibition";
import { BackNumber } from "./back-number";
import { BackNumberConfig } from "./back-number-config";
import { Progression } from "./progression";
import { StockGroup } from "./stock-group";
import { PayoutConfig } from "./payoutConfig";
import { rodeoExpenseItems } from "./rodeoExpenseItems"
import { OrganizationCheckRegister } from "./organizationCheckRegister";
import { pointNominationRodeoStatus } from "./points/pointNominationRodeoStatus";


export class Rodeo {
    id: number;
    name: string = '';
    organization: Organization = new Organization();
    sanctionedOrganizations: any[] = [];
    producer: Producer = new Producer();
    arena: Arena = new Arena();
    secretary: Secretary = new Secretary();
    startDate: string;
    endDate: string;
    membershipRequired: boolean;
    registrationTimezoneOffset: number;
    rodeoTimezone: string;
    rodeoTimezoneOffset: number;
    registrationStartDate: string;
    lateRegistrationStartDate: string;
    registrationEndDate: string;
    buddyMax: number = 2;

    isJackpot: boolean;
    officeFee: number;
    lateFee: number;
    lateFeeType: string;
    defaultPhotoPrice: number;
    officeFeeEntryChargePer: string;
    paymentPlanFee: number;
    paymentPlanEnrollmentStartDate?: string;
    paymentPlanEnrollmentEndDate?: string;
    paymentPlanDueBy?: string;
    checksDueBy?: string;

    maleAgeRequirement: number;
    femaleAgeRequirement: number;
    maleAgeCap: number;
    femaleAgeCap: number;

    turnoutGraceDeadline: string;
    hideEntryCounts: boolean;
    enterOneClassPerDiscipline: boolean;
    penaltiesCanPlace: boolean;

    tradeCap: number = 1;
    tradeDeadline: string;
    emergencyTradeDeadline: string;

    addedMoney: number = 0;
    guaranteedMoney: number = 0;

    agreementFileName: string = '';
    websiteURL: string = '';
    phone: string = '';
    done: boolean;

    drawn: boolean;
    published: boolean;
    notifiedContestants: boolean;

    updated: string;

    test: boolean;

    hotelRooms: any[];
    clothing: any[];
    rodeoExpenseItems: rodeoExpenseItems[] = [];
    rodeoEvents: RodeoEvent[] = [];
    exhibitions: Exhibition[] = [];
    backNumbers: BackNumber[] = [];
    progressions: Progression[] = [];
    backNumberConfigs: BackNumberConfig[] = [];
    stockGroups: StockGroup[] = [];
    payoutConfigs: PayoutConfig[] = [];
    organizationCheckRegister: OrganizationCheckRegister[] = [];

    stallsAvailable: number;
    stallsMaxPerContestant: number;
    stallPrice: number;
    rvsAvailable: number;
    rvsMaxPerContestant: number;
    rvPrice: number;

    allowPermitsToEnter: boolean;
    allowEntryComments: boolean;

    pointNominationRodeoStatus: pointNominationRodeoStatus[] = [];
    pointsNominationEnabled: boolean;

    constructor() {
        this.defaultPhotoPrice = 9.99;
        this.officeFee = 0;
        this.lateFee = 0;
        this.lateFeeType = 'PERRIDER';
        this.allowPermitsToEnter = true;
    }
}


// WEBPACK FOOTER //
// ./src/model/rodeo.ts